// client/src/components/EventsSection.js
import React from 'react';
// Json code for comments.
const events = [
  {
    title: 'Getting Started with BetterTurns',
    date: 'May 15, 2025',
    description:
      'A practical walkthrough of how BetterTurns works, what it means to join the co-op, and how to get started as a new store.',
    status: 'Open Soon',
  },
  {
    title: 'POS Demo & Walkthrough',
    date: 'June 5, 2025',
    description:
      'A guided demo of our POS system and how it connects to the BetterTurns cloud — ideal for pilot stores and partners.',
    status: 'Coming Soon',
  },
  {
    title: 'Understanding Co-op Analytics',
    date: 'June 20, 2025',
    description:
      'We’ll explore what “shared analytics” really means for small retailers, and how co-op members can use the data to grow smarter.',
    status: 'Coming Soon',
  },
];

const EventsSection = () => {
  return (
    <section className="bg-soft-earth py-16 px-6 md:px-20 text-center">
      <div className="max-w-5xl mx-auto">
        <h3 className="text-3xl md:text-4xl font-extrabold text-primary mb-6">
          Upcoming Events & Workshops
        </h3>
        <p className="text-gray-700 mb-10 text-lg max-w-2xl mx-auto">
          Join us as we launch a new movement for small retailers. Our events
          are designed to inform, engage, and support your growth.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
          {events.map((event, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg shadow-md p-6 border border-cool-gray"
            >
              <h4 className="text-xl font-semibold text-deep-navy mb-1">
                {event.title}
              </h4>
              <p className="text-sm text-gray-500 mb-2">{event.date}</p>
              <p className="text-gray-700 text-base mb-4">
                {event.description}
              </p>

              <span className="inline-block bg-sunshine-yellow text-deep-navy px-3 py-1 rounded-full text-sm font-medium">
                {event.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
